import React from 'react'
import CatagoryWidget from "../../blog/CatagoryWidget";
import BannerWidget from "../../blog/BannerWidget";
import BlogDetailsContent7 from '../Respectarealegislatiei/BlogDetailsContent7';


function BlogDetailsWrap7() {
  return (
    <>
      <div className="blog-details-area sec-mar-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <BlogDetailsContent7 />
            </div>
            <div className="col-lg-4">
              <CatagoryWidget />
              <BannerWidget />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default BlogDetailsWrap7